/**
 * Catálogo de sedes para el **selector de sede** del usuario multi-sede.
 *
 * Llama a `GET /api/v1/sedes` (vía `lib/api`), que el backend reserva al permiso
 * `all` (solo-admin/multi-sede; ver `application/api/domains/sedes.py`). Por eso
 * el hook que lo consume se habilita solo para usuarios multi-sede.
 *
 * Se limita a lo que el selector necesita (id, nombre, ciudad, estado activo);
 * el dominio de sedes completo (CRUD) es de una feature posterior. Esto NO toca
 * el cliente compartido ni el SSR: es una llamada de feature sobre `lib/api`.
 */
import { api } from "@/lib/api";

/** Item del catálogo de sedes en la vista `list` del backend (`sede_to_dict`). */
export interface SedeOption {
  id: number;
  nombre: string;
  ciudad: string | null;
  activa: boolean;
}

interface SedesListResponse {
  items: SedeOption[];
}

/** Lista las sedes disponibles para el selector. Requiere permiso `all` (multi-sede). */
export async function fetchSedes(): Promise<SedeOption[]> {
  const response = await api.get("sedes");
  const body = (await response.json()) as SedesListResponse;
  return body.items;
}
